import {RdstationTypes} from '@root/redux/rdstation/rdstation.types'

export const setFormInitial = (visible) => {
  return {
    type: RdstationTypes.SET_FORM_INITIAL,
    payload: {visible},
  }
}
